import * as React from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';

interface IStatusProps {
  code: number;
  reason?: string;
  children?: React.ReactNode;
}

const Status = ({ code, reason, children }: IStatusProps) => (
  <Route
    // tslint:disable:jsx-no-lambda
    render={({ staticContext }) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const betterStaticContext = staticContext as any;
      if (betterStaticContext) {
        betterStaticContext.status = code;
        betterStaticContext.reason = reason;
      }
      return children;
    }}
  />
);

interface ILoadFailedProps {
  reason?: string;
}

const NotFound: React.FC<ILoadFailedProps & RouteComponentProps> = ({
  reason,
}) => {
  return (
    <Status code={404} reason={reason}>
      {null}
    </Status>
  );
};

const LoadFailed: React.FC<ILoadFailedProps & RouteComponentProps> = ({
  reason,
}) => {
  return (
    <Status code={500} reason={reason}>
      {null}
    </Status>
  );
};

export const PageLoadFailed = withRouter(LoadFailed);

export const PageNotFound = withRouter(NotFound);

export default withRouter(NotFound);
